module.exports = "table {\n  width: 50%; }\n\nth {\n  background: #d9d9d9; }\n\n.language {\n  float: left;\n  margin-right: 2%;\n  width: 25%;\n  font-weight: bold;\n  background: lightblue; }\n\n/*input{\n  width: 100%;\n}*/\n\n.wideInput {\n  width: 100%; }\n\n.border {\n  width: 50%;\n  border: 1px solid #ccc; }\n\n.title {\n  margin-bottom: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/content/new-offer/customer-profile/new-contact-person/new-contact-person.component.scss
// module id = ./src/app/content/new-offer/customer-profile/new-contact-person/new-contact-person.component.scss
// module chunks = main